import React from 'react';
import { Checkbox, Form } from 'antd';
import './UserCheckBoxAgreements.less';
import { useAppSelector } from '../../store/hooks';
import { useLocation } from 'react-router-dom';

export const UserCheckBoxAgreements = () => {
  const { properties } = useAppSelector((state) => state.root);
  const location = useLocation();
  const { web_agree_documents_links } = properties;

  const privacy_policy_text = web_agree_documents_links?.privacy_policy_text.split('#');
  const personal_data_text = web_agree_documents_links?.personal_data_text.split('#');
  const terms_of_use_text = web_agree_documents_links?.terms_of_use_text.split('#');

  return (
    <>
      <div className="agreement-text">
        {location?.pathname === '/create-user' ? (
          <>
            Чтобы обезопасить ваши данные и наш сервис, <br />
            пожалуйста, подтвердите, что вы ознакомились
            <br /> и согласны со следующими документами:
          </>
        ) : (
          <>
            Чтобы обезопасить ваши данные <br />и наш сервис, пожалуйста, подтвердите, <br />
            что вы ознакомились и согласны <br />
            со следующими документами:
          </>
        )}
      </div>
      <Form.Item
        name="agree1"
        /*className="form-agree-checkbox agreement-checkbox-label"*/
        style={{
          height: '42px',
          marginBottom: '20px',
          fontSize: '14px',
        }}
        valuePropName="checked"
        wrapperCol={{
          style: { marginRight: '0px', textAlign: 'left' },
        }}
        rules={[
          {
            required: true,
            validator: async (_, checked) => {
              if (!checked) {
                return Promise.reject(new Error(''));
              }
            },
          },
        ]}
      >
        <Checkbox style={{ minHeight: 'auto' }} className="ml5">
          <span className="checkbox-label">
            {privacy_policy_text && privacy_policy_text[0]}
            <a target="_blank" href={`${web_agree_documents_links?.privacy_policy}`}>
              {privacy_policy_text && privacy_policy_text[1]}
            </a>
          </span>
        </Checkbox>
      </Form.Item>

      <Form.Item
        name="agree2"
        className="form-agree-checkbox agreement-checkbox-label"
        style={{ height: '42px', marginBottom: '20px' }}
        valuePropName="checked"
        wrapperCol={{ style: { marginRight: '0px', textAlign: 'left' } }}
        rules={[
          {
            required: true,
            validator: async (_, checked) => {
              if (!checked) {
                return Promise.reject(new Error(''));
              }
            },
          },
        ]}
      >
        <Checkbox style={{ minHeight: 'auto' }} className="ml5">
          <span className="checkbox-label">
            {personal_data_text && personal_data_text[0]}
            <a target="_blank" href={`${web_agree_documents_links?.personal_data}`}>
              {personal_data_text && personal_data_text[1]}
            </a>
          </span>
        </Checkbox>
      </Form.Item>

      <Form.Item
        name="agree3"
        className="form-agree-checkbox agreement-checkbox-label"
        style={{ height: '42px', marginBottom: '20px' }}
        valuePropName="checked"
        wrapperCol={{ style: { marginRight: '0px', textAlign: 'left' } }}
        rules={[
          {
            required: true,
            validator: async (_, checked) => {
              if (!checked) {
                return Promise.reject(new Error(''));
              }
            },
          },
        ]}
      >
        <Checkbox style={{ minHeight: 'auto' }} className="ml5">
          <span className="checkbox-label">
            {terms_of_use_text && terms_of_use_text[0]}
            <a target="_blank" href={`${web_agree_documents_links?.terms_of_use}`}>
              {terms_of_use_text && terms_of_use_text[1]}
            </a>
          </span>
        </Checkbox>
      </Form.Item>
    </>
  );
};
